"use client";

import React, { useState } from "react";
import HeaderInner from "../../utility/HeaderInner";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaBuilding,
  FaPhoneAlt,
} from "react-icons/fa";

const contactData = {
  header: {
    title: "Contact Us",
    shortDescription: "Get in touch with Coempt Edu Teck across India",
  },
  map: {
    defaultSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.497141962844!2d78.436291!3d17.437462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91bb3c1a7b0f%3A0x62f7e22b6e9df32e!2sMadhura%20Nagar%2C%20Yousufguda%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1693400000000",
    width: "100%",
    height: "100%",
  },
  offices: [
    {
      type: "Head Office",
      icon: "FaBuilding",
      address:
        "# F-28, 8-3-224/4/9/C, Madhura Nagar, Yousufguda, Hyderabad - 500038, Telangana.",
      phone: ["040-23750190", "7660912111"],
      email: "info@coempt.in",
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.497141962844!2d78.436291!3d17.437462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91bb3c1a7b0f%3A0x62f7e22b6e9df32e!2sMadhura%20Nagar%2C%20Yousufguda%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1693400000000",
    },
    {
      type: "Regional Office - Karnataka",
      icon: "FaMapMarkerAlt",
      address:
        "Coempt Eduteck Pvt Ltd, Synerge Workspace LLP, 11th Main, Jayanagar, 4th T Block, Bengaluru, Karnataka, 560041",
      phone: ["+91 93435 30309"],
      email: null,
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d972.1825623349541!2d77.58815608937859!3d12.925051223880333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae154598ce1ce7%3A0x5be1f7a5e151805e!2sSYNERGE%20CO-WORKING%20SPACE%20JAYANAGAR!5e0!3m2!1sen!2sin!4v1775715236816!5m2!1sen!2sin",
    },
    
    /*{
      type: "Regional Office - Karnataka",
      icon: "FaMapMarkerAlt",
      address:
        "Coempt Eduteck Pvt Ltd, 12, 30th cross road, opp. Sagar Hospital, Pattabhirama Nagar, Jayanagar, Bengaluru, Karnataka, 560041",
      phone: ["+91 93435 30309"],
      email: null,
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.093123!2d77.594562!3d12.971599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167f6d5a7c3d%3A0x123456789abcdef!2sIndian%20Express%20Building%2C%20Queens%20Road%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1693600000000",
    },*/
    {
      type: "Regional Office – Tamil Nadu & Kerala",
      icon: "FaMapMarkerAlt",
      address:
        "#10, 4th Floor, Sona Towers, Rajendra Prasad Road, Chrompet, Chennai - 600044",
      phone: ["+91 98405 44688"],
      email: null,
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.459123!2d80.162567!3d12.948079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525f6e8a6a123%3A0xabcdef987654321!2sChrompet%2C%20Chennai!5e0!3m2!1sen!2sin!4v1693601111111",
    },
    {
      type: "Regional Office – Nagpur",
      icon: "FaMapMarkerAlt",
      address: "Plot No. 32/A, Pande Layout, Khamla Road, Nagpur - 440025",
      phone: ["+91 98485 40850"],
      email: null,
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.505123!2d79.088209!3d21.145800!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c123456789%3A0xabcdef123456789!2sKhamla%2C%20Nagpur!5e0!3m2!1sen!2sin!4v1693602222222",
    },
  ],
  salesEnquiry: [
    {
      region: "South & East India (HO)",
      phone: "+91-9848531838",
      email: "sales.east@coempt.in",
    },
    {
      region: "North & West India (HO)",
      phone: "+91-9848540850",
      email: "sales.west@coempt.in",
    },
    {
      region: "Andhra Pradesh & Telangana",
      phone: "+91-9848531838",
      email: "ikiran@coempt.in",
    },
    {
      region: "Tamil Nadu & Kerala",
      phone: "+91 9840544688",
      email: "suriya.kumar@coempt.in",
    },
    {
      region: "Karnataka",
      phone: "+91 9343530309",
      email: "shashikg@coempt.in",
    },
  ],
};

const iconMap = {
  FaBuilding: FaBuilding,
  FaMapMarkerAlt: FaMapMarkerAlt,
};

const ContactUs = () => {
  const [selectedRegion, setSelectedRegion] = useState("");

  const selectedOffice = contactData.offices.find(
    (office) => office.type === selectedRegion
  );

  const handleSendEmail = (e) => {
    e.preventDefault();

    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const organization = document.getElementById("subject").value;
    const phone = document.getElementById("number").value;
    const issue = document.getElementById("issue").value;
    const region = document.getElementById("region").value;
    const message = document.getElementById("message").value;

    // Fixed email address
    const toEmail = "mahesht@coempt.in";

    const mailtoLink = `mailto:${toEmail}?subject=${encodeURIComponent(
      `Enquiry from ${name} - ${issue}`
    )}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nOrganization: ${organization}\nPhone: ${phone}\nRegion: ${region}\nMessage: ${message}`
    )}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="mt-70">
      <HeaderInner
        title={contactData.header.title}
        shortDescription={contactData.header.shortDescription}
      />
      <section className="bg-light py-5 px-3">
        <div className="row">
          {/* LEFT: Office Info */}
          <div className="col-md-6">
            <div className="mb-4">
              <select
                className="form-select"
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">Select Region</option>
                {contactData.offices.map((office, idx) => (
                  <option key={idx} value={office.type}>
                    {office.type}
                  </option>
                ))}
              </select>
            </div>

            {selectedOffice && (
              <div className="card shadow-sm mb-4">
                <div className="card-body">
                  {React.createElement(
                    iconMap[selectedOffice.icon] || FaMapMarkerAlt,
                    { className: "text-primary fs-3 mb-3" }
                  )}
                  <h5 className="card-title mb-2">{selectedOffice.type}</h5>
                  <p className="card-text text-secondary">
                    {selectedOffice.address}
                  </p>
                  {selectedOffice.phone.map((num, idx) => (
                    <p key={idx} className="text-secondary mb-1">
                      <FaPhoneAlt className="me-2" /> {num}
                    </p>
                  ))}
                  {selectedOffice.email && (
                    <p className="text-secondary mb-0">
                      <FaEnvelope className="me-2" /> {selectedOffice.email}
                    </p>
                  )}
                </div>
              </div>
            )}

            <div
              className="w-100 mb-4 rounded shadow overflow-hidden"
              style={{ height: "300px" }}
            >
              <iframe
                src={selectedOffice?.mapSrc || contactData.map.defaultSrc}
                width={contactData.map.width}
                height={contactData.map.height}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* RIGHT: Contact Form */}
          <div className="col-md-6 talk-us__item">
            <form onSubmit={handleSendEmail}>
              <div className="row g-3">
                <div className="col-sm-6">
                  <label htmlFor="name">Your name*</label>
                  <input type="text" id="name" placeholder="Your name" />
                </div>
                <div className="col-sm-6">
                  <label htmlFor="email">Your Email*</label>
                  <input type="email" id="email" placeholder="Email" />
                </div>
                <div className="col-sm-6">
                  <label htmlFor="subject">Organization*</label>
                  <input
                    type="text"
                    id="subject"
                    placeholder="Organization Name"
                  />
                </div>
                <div className="col-sm-6">
                  <label htmlFor="number">Your Phone*</label>
                  <input
                    type="number"
                    id="number"
                    placeholder="Your Phone"
                    maxLength={10}
                  />
                </div>
                <div className="col-sm-12">
                  <label htmlFor="issue">Facing Issues*</label>
                  <select
                    id="issue"
                    className="form-select"
                    required
                    style={{ borderRadius: 0 }}
                  >
                    <option value="">Select an issue</option>
                    <option value="Technical Support">Technical Support</option>
                    <option value="Billing Issue">Billing Issue</option>
                    <option value="Account Access">Account Access</option>
                    <option value="Training Request">Training Request</option>
                    <option value="General Enquiry">General Enquiry</option>
                  </select>
                </div>
                <div className="col-sm-12">
                  <label htmlFor="region">Selected Region*</label>
                  <input
                    type="text"
                    id="region"
                    value={selectedRegion}
                    readOnly
                    className="form-control"
                    placeholder="No region selected"
                    style={{ borderRadius: 0 }}
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="message">Message*</label>
                  <textarea
                    id="message"
                    placeholder="I have a problem with ..."
                  />
                </div>
              </div>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
